import {Component, inject, OnInit} from '@angular/core';
import {APP_ROUTES} from "../../app.routes.definition";
import {Router, RouterLink} from "@angular/router";
import {NativeAPIService, TargetPlatform} from "../../services/native/native-api.service";
import {LogService} from "../../services/log.service";
import {ModalService} from "../../services/modal.service";
import ErrorModalComponent, {ErrorModalData} from "../../components/error-modal/error-modal.component";
import {TryTerraNativeService} from "../../services/native/try-terra-native.service";
import {
    AndroidHealthConnectModalContentComponent
} from "./android-health-connect-modal-content/android-health-connect-modal-content.component";
import {NavigationService} from "../../services/navigation.service";
import LoaderComponent from "../../components/loader/loader.component";

@Component({
    selector: 'app-ask-import-health-data-page',
    standalone: true,
    imports: [
        LoaderComponent
    ],
    templateUrl: './ask-import-health-data-page.component.html',
    styleUrl: './ask-import-health-data-page.component.css'
})
export default class AskImportHealthDataPageComponent implements OnInit {
    #nativeAPIService = inject(NativeAPIService);
    #tryTerraNativeService = inject(TryTerraNativeService);
    #logService = inject(LogService);
    #router = inject(Router);
    #modalService = inject(ModalService);
    #navigationService = inject(NavigationService);

    tutorialPath = APP_ROUTES.ASK_IMPORT_HEALTH_DATA_TUTORIAL();

    isCheckingNativePlatform = true;
    healthConnectAvailable = false;
    currentPlatform?: TargetPlatform;

    TargetPlatform = TargetPlatform;

    constructor() {
    }

    ngOnInit() {
        this.#navigationService.saveCurrentRoute();

        if (this.#nativeAPIService.isAvailable()) {
            this.#nativeAPIService.defaultTargetPlatform().then(targetPlatform => {
                this.currentPlatform = targetPlatform;
                if (targetPlatform === TargetPlatform.android) {
                    this.#tryTerraNativeService.isHealthConnectAvailable().then(healthConnectAvailable => {
                        this.healthConnectAvailable = healthConnectAvailable;
                        if (this.healthConnectAvailable) {
                            // if health connect is available,
                            // go to the tutorial page directly
                            this.checkAndGoNext();
                        }
                        this.isCheckingNativePlatform = false;
                    }).catch(reason => {
                        this.#logService.error(reason);
                        this.isCheckingNativePlatform = false;
                    });
                } else {
                    // if not android, skip health connect check and
                    // go to the tutorial page
                    this.checkAndGoNext();
                    this.isCheckingNativePlatform = false;
                }
            }).catch(reason => {
                this.#logService.error(reason);
                this.isCheckingNativePlatform = false;
            });
        } else {
            this.isCheckingNativePlatform = false;
            this.#navigationService.navigateBack();
        }
    }

    enableHealthConnect() {
        if (this.currentPlatform === TargetPlatform.android) {
            this.#modalService.open(AndroidHealthConnectModalContentComponent);
        }
    }

    checkAndGoNext() {
        if (this.#tryTerraNativeService.isAvailable() && this.currentPlatform === TargetPlatform.android) {
            this.#tryTerraNativeService.isHealthConnectAvailable().then(healthConnectAvailable => {
                if (healthConnectAvailable) {
                    this.#router.navigate([this.tutorialPath]);
                } else {
                    this.#modalService.open<ErrorModalData, ErrorModalComponent>(ErrorModalComponent, {
                        data: {
                            message: 'L\'App "Connessione Salute" non risulta installata.'
                        }
                    });
                }
            }).catch(reason => {
                this.#logService.error(reason);
                this.#modalService.open<ErrorModalData, ErrorModalComponent>(ErrorModalComponent, {
                    data: {
                        error: reason,
                        message: 'Non è stato possibile verificare l\'installazione dell\'App "Connessione Salute".'
                    }
                });
            });
        } else {
            this.#router.navigate([this.tutorialPath]);
        }
    }

    goBack() {
        this.#navigationService.navigateBack();
    }
}
